export default "__VITE_ASSET__DKyWMe$4__"